/* eslint-disable complexity */
import dayjs from "dayjs";
import { Appointment, TimeSlotLength } from "./Appointment";

enum Canceled {
    byUser = "User",
    byCoach = "Coach",
}

export const getAppointmentStatus = (appointment: Appointment): string => {
    if (appointment.canceledBy) {
        if (appointment.canceledBy === Canceled.byUser) {
            return "Durch Nutzer storniert";
        }
        return "Durch Coach storniert";
    }

    const startDateTime = dayjs.unix(
        parseInt(appointment.startDateTime as unknown as string, 10)
    );
    if (startDateTime.isAfter(dayjs())) {
        return "Geplant";
    }
    if (startDateTime.isBefore(dayjs().subtract(TimeSlotLength, "m"))) {
        return "Abgeschlossen";
    }

    const isAppointmentInProgress =
        startDateTime.isBefore(dayjs()) &&
        startDateTime.isAfter(dayjs().subtract(TimeSlotLength, "m"));
    if (isAppointmentInProgress) {
        return "im Gange";
    }

    return "-";
};
